import { useQuery } from "@tanstack/react-query";
import { createContext, ReactNode, useContext } from "react";
import { useAuthContext } from "../Auth";
import { instance } from "../../api/apiBase";

const NotificationContext = createContext<{
  newestNotifications: Notification[] | undefined;
  totalUnread: number;
  refetchTotalUnreadNotification: () => void;
}>({
  newestNotifications: [],
  totalUnread: 0,
  refetchTotalUnreadNotification: () => {}
});

const notificationApi = {
  getNewest: () =>
    instance.get("/portal/v1/notifications/newest").then((res) => res.data),
  getTotalUnread: () =>
    instance
      .get("/portal/v1/notifications/unread_count")
      .then((res) => res.data?.total_unread || 0)
};

export function NotificationProvider({ children }: { children: ReactNode }) {
  const { auth } = useAuthContext();

  const { data: totalUnread, refetch: refetchTotalUnreadNotification } =
    useQuery({
      queryKey: ["TOTAL_UNREAD_NOTIFICATIONS"],
      queryFn: () => notificationApi.getTotalUnread()
    });

  const { data: newestNotifications } = useQuery({
    queryKey: ["NEWEST_NOTIFICATIONS"],
    queryFn: async () => {
      const newestNoti = await notificationApi.getNewest();
      if ((newestNotifications || []).length) refetchTotalUnreadNotification();
      return newestNoti;
    },
    refetchInterval: 30000,
    enabled: Boolean(auth)
  });

  return (
    <NotificationContext.Provider
      value={{
        newestNotifications,
        totalUnread,
        refetchTotalUnreadNotification
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useNotificationContext() {
  return useContext(NotificationContext);
}
